(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("anteros-react-nestable", [], factory);
	else if(typeof exports === 'object')
		exports["anteros-react-nestable"] = factory();
	else
		root["anteros-react-nestable"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 